import React from "react";

import Form from "./Form";

import {
  ConditionTextContainer,
  StyledConditionsLink,
  StyledRightSection,
} from "./style";

const RightSection = ({ data = {}, handleCallbackFormView }) => {
  const { form, conditions } = data;

  const ConditionsLink = (
    <StyledConditionsLink
      variant="paragraph3"
      dangerouslySetInnerHTML={{ __html: conditions }}
    />
  );

  return (
    <StyledRightSection>
      <Form {...form} handleCallbackFormView={handleCallbackFormView} />
      <ConditionTextContainer>{ConditionsLink}</ConditionTextContainer>
    </StyledRightSection>
  );
};

export default RightSection;
